// 搜题路由
export const tiku_search = [
  {
    path: "/tiku_search",
    name: "搜题",
    component: (resolve) => require(["@p/tiku_search/tiku_search.vue"], resolve),
  },
];
